module.exports = __webpack_public_path__ + "static/media/introVid.c0c58638.mp4";